import { useMutation, useQueryClient } from "@tanstack/react-query";
import snakecaseKeys from "snakecase-keys";
import {
  GET_USER_PROFILE_MESSAGE_TYPE,
  setUserProfile,
  type UserProfile,
} from "@leagueplatform/user-profile-api";

export interface Options {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}

export const useUpdateUserProfile = (options?: Options) => {
  const queryClient = useQueryClient();
  const { onSuccess, onError } = options || {};

  const { mutateAsync: updateUserProfileMutation, isLoading } = useMutation({
    mutationFn: (userProfile: Partial<UserProfile>) =>
      setUserProfile(userProfile),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [GET_USER_PROFILE_MESSAGE_TYPE],
      });
      if (onSuccess) onSuccess();
    },
    onError: (error: Error) => {
      if (onError) onError(error);
    },
  });

  const updateUserProfile = async (userProfile: Partial<UserProfile>) => {
    const serializedBody = snakecaseKeys(userProfile, { deep: true });
    await updateUserProfileMutation(serializedBody);
  };

  return { updateUserProfile, isLoading };
};
